import { Award, Users, Globe, Trophy } from 'lucide-react';
import styles from './About.module.css';

interface AboutProps {
  title?: string;
  overview?: string;
  developmentStory?: string;
  accomplishments?: Array<{
    icon: string;
    value: string;
    label: string;
  }>;
}

const About = ({
  title = 'About Cosmos Horizon',
  overview = 'Cosmos Horizon is a next-generation space exploration game that pushes the boundaries of interactive entertainment. Set in a vast, procedurally generated universe, players embark on an epic journey to explore distant galaxies, engage in tactical space combat, and build lasting alliances with players from around the world.',
  developmentStory = 'Developed by a passionate team of veteran game designers and space enthusiasts, Cosmos Horizon represents five years of dedicated work. Our vision was to create a game that captures the wonder and mystery of space exploration while delivering engaging gameplay mechanics and stunning visuals.',
  accomplishments = [
    { icon: 'users', value: '2M+', label: 'Active Players' },
    { icon: 'globe', value: '150+', label: 'Countries Played' },
    { icon: 'award', value: '4.8', label: 'User Rating' },
    { icon: 'trophy', value: '12', label: 'Game Awards' }
  ]
}: AboutProps) => {
  const getIconComponent = (iconName: string) => {
    switch (iconName) {
      case 'users':
        return Users;
      case 'globe':
        return Globe;
      case 'award':
        return Award;
      case 'trophy':
        return Trophy;
      default:
        return Award;
    }
  };

  return (
    <section id="about" className={styles.about}>
      <div className={styles.background} />

      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
        </div>

        {/* Content Grid */}
        <div className={styles.contentGrid}>
          {/* Overview */}
          <div className={styles.contentBlock}>
            <h3 className={styles.sectionHeading}>The Journey Awaits</h3>
            <p className={styles.text}>{overview}</p>
            <p className={styles.text}>{developmentStory}</p>
          </div>

          {/* Accomplishments */}
          <div className={styles.accomplishments}>
            {accomplishments.map((item, index) => {
              const IconComponent = getIconComponent(item.icon);
              return (
                <div key={index} className={styles.statCard}>
                  <div className={styles.statIcon}>
                    <IconComponent size={28} />
                  </div>
                  <div className={styles.statValue}>{item.value}</div>
                  <div className={styles.statLabel}>{item.label}</div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Bottom Section */}
        <div className={styles.bottomSection}>
          <h3 className={styles.bottomHeading}>
            Join millions of explorers in the ultimate space adventure
          </h3>
        </div>
      </div>
    </section>
  );
};

export default About;
